import { createSelector } from "@reduxjs/toolkit";

import { configReferencedNodeIds, extractNodeValueRefIds, extractRefIds } from "../../shared/index.ts";
import { nodeDesignsByIdSelector } from "../selectors/nodeDesignsCoreSelectors.ts";
import { conditionsStateSelector, effectsByIdSelector } from "../selectors/triggerSelectors.ts";

const effectReferencedNodeIdsSelector = createSelector(effectsByIdSelector, (effectsById) =>
  Object.values(effectsById).flatMap((e) => configReferencedNodeIds(e.config)),
);

const conditionReferencedNodeIdsSelector = createSelector(conditionsStateSelector, ({ byId }) =>
  Object.values(byId).flatMap((c) => configReferencedNodeIds(c.config)),
);

const nodeConfigReferencedNodeIdsSelector = createSelector(nodeDesignsByIdSelector, (designsById) =>
  Object.values(designsById).flatMap((d) => [
    ...extractRefIds(d.config.nodeReferences),
    ...extractNodeValueRefIds(d.config),
  ]),
);

export const anyReferencesToNodeSelector = createSelector(
  [effectReferencedNodeIdsSelector, conditionReferencedNodeIdsSelector, nodeConfigReferencedNodeIdsSelector],
  (effectIds, conditionIds, nodeConfigIds) => {
    const referencedNodeIds = new Set([...effectIds, ...conditionIds, ...nodeConfigIds]);
    return (nodeId: number) => referencedNodeIds.has(nodeId);
  },
);

export type AnyReferencesToNode = ReturnType<typeof anyReferencesToNodeSelector>;
